import http from '@/utils/request';

//获取商城播报
export function getNotice() {
  return http.request({
    url: '/system/notice/restful/list',
    method: 'get',
  });
}

//获取首页轮播
export function getBanner(params) {
  return http.request({
    url: '/mro/banner/list?isShow=1',
    method: 'get',
    params,
  });
}
//获取外部首页轮播
export function getBannerRestful(params) {
  params.isShow = 1;
  return http.request({
    url: '/mro/banner/restful/list',
    method: 'get',
    params,
  });
}
// 获取商品分类
export function getCategoryListTree() {
  return http.request({
    url: '/mro/category/portal/tree',
    method: 'get',
  });
}

// 外部获取商品分类
export function getCategoryListTreerestful(query) {
  return http.request({
    url: '/mro/category/restful/portal/tree',
    method: 'get',
    params: query,
  });
}

// 获取商品详情
export function getProductInfo(id) {
  return http.request({
    url: `/mro/portal/product/${id}`,
    method: 'get',
  });
}

// 中小企业获取未登录商品详情
export function getRestProductInfoInner(id) {
  return http.request({
    url: `/mro/portal/product/rest/${id}`,
    method: 'get',
  });
}

// 外部获取商品详情
export function getProductInfoRestful(id) {
  return http.request({
    url: `/mro/portal/product/restful/${id}`,
    method: 'get',
  });
}

// 产品搜索
export function searchProduct(query) {
  return http.request({
    url: `/mro/portal/product/getList`,
    method: 'get',
    params: query,
  });
}

// 外部产品搜索
export function searchProductRestful(query) {
  return http.request({
    url: `/mro/portal/product/restful/getSopList`,
    method: 'get',
    params: query,
  });
}

//获取品类精选
export function indexPick(query) {
  return http.request({
    url: `/mro/category/portal/catalog`,
    method: 'get',
    params: query,
  });
}
//获取外部品类精选
export function indexPickRestful(query) {
  return http.request({
    url: `/mro/category/restful/selfCatalog`,
    method: 'get',
    params: query,
  });
}

//获取联想词
export function matchAnswer(query) {
  return http.request({
    url: `/mro/portal/product/matchAnswer`,
    method: 'get',
    params: query,
  });
}

//获取外部联想词
export function matchAnswerRestful(query) {
  return http.request({
    url: `/mro/portal/product/restful/matchAnswer`,
    method: 'get',
    params: query,
  });
}

/** 获取企业控制台商品列表 */
export function getAdminProductList(query) {
  return http.request({
    url: `/mro/product/getAdminList`,
    method: 'get',
    params: query,
  });
}

// 导出企业控制台商品列表
export function exportAdminProductList(query) {
  return http.exportRequest({
    url: `/mro/product/exportAdminList`,
    method: 'post',
    params: query,
  });
}

// mro / product / lowerShelf / { productId };

export function productOffShelf(query) {
  return http.request({
    url: `/mro/product/lowerShelf/${query.id}`,
    method: 'put',
  });
}

/** 产品详情 */

//获取活动专区列表
export function getactivityZoneList(query) {
  return http.request({
    url: `/mro/activityZone/rest/list`,
    method: 'get',
    params: query,
  });
}

//获取活动专区下分类列表
export function getactivityZoneCategoriesList(id, query) {
  return http.request({
    url: `/mro/zoneCategory/rest/getCategories/${id}`,
    method: 'get',
    params: query,
  });
}

//获取活动专区下所有的产品
export function getactivityZoneProductList(id, query) {
  return http.request({
    url: `/mro/portal/product/restful/getZoneList/${id}`,
    method: 'get',
    params: query,
  });
}
// 获取积分商品列表
export function getIntegralProductList(query) {
  return http.request({
    url: `/mro/portal/product/restful/getZoneList/${query.zoneId}`,
    method: 'get',
    params: query,
  });
}

//添加收藏
export function addCollect(data) {
  return http.request({
    url: `/mro/collection`,
    method: 'post',
    data: data,
  });
}
//移除收藏
export function removeCollect(id, data) {
  return http.request({
    url: `/mro/collection/remove/${id}`,
    method: 'delete',
    params: data,
  });
}
//获取列表
export function getCollect(query) {
  return http.request({
    url: `/mro/collection/list`,
    method: 'get',
    params: query,
  });
}
//查询是否收藏
export function getIsCollect(id, query) {
  return http.request({
    url: `/mro/collection/isCollection/${id}`,
    method: 'get',
    params: query,
  });
}

//获取供应商联想词
export function matchSupplierAnswer(query) {
  return http.request({
    url: `/system/middle/supplier/searchPortalSupplier`,
    method: 'get',
    params: query,
  });
}

//获取供应商有的产品分类
export function selectCategoryBySupplierName(name) {
  return http.request({
    url: `/mro/portal/product/selectCategoryBySupplierName?supplierCompanyName=${name}`,
    method: 'get',
  });
}

// 获取产品对应公司的客服
export function getProductCustService(productId) {
  return http.request({
    url: `/mro/wechat/customerService/rest/getProductCustService/${productId}`,
    method: 'get',
  });
}

// 销售中心 合同列表

export function getContractProductList(query) {
  return http.request({
    url: `/mro/product/getContractProductList`,
    method: 'get',
    params: query,
  });
}

/* 
获取自营新品推荐商品列表
  GET /newRecmd/rest/getSopList
  接口ID：131829570
  接口地址：https://app.apifox.com/link/project/1961013/apis/api-131829570 */

export function getNewRecmdProducts() {
  return http.request({
    url: '/mro/newRecmd/getInnerList',
    method: 'get',
  });
}

//  可获取推荐商品列表

export function getAddRecmdProducts(query) {
  return http.request({
    url: '/mro/newRecmd/addSopList',
    method: 'get',
    params: query,
  });
}

//  新增推荐商品
export function addRecmdProduct(data) {
  return http.request({
    url: '/mro/newRecmd/addInnerProducts',
    method: 'post',
    data,
  });
}

// 删除推荐商品
export function delRecmdProduct(data) {
  return http.request({
    url: '/mro/newRecmd/removeProducts',
    method: 'delete',
    data,
  });
}

// 热门推荐分类列表 /category/popularRecommend

export function getPopularRecommendCategory() {
  return http.request({
    url: '/mro/category/popularRecommend',
    method: 'get',
  });
}

// 开启关闭推荐 /category/recommendStatus

export function recommendStatus(data) {
  return http.request({
    url: '/mro/category/recommendStatus',
    method: 'post',
    data,
  });
}

// 热门推荐 查询商品分类关联商品列表 /categoryProduct/list

export function getPopularCategoryProduct(query) {
  return http.request({
    url: '/mro/categoryProduct/list',
    method: 'get',
    params: query,
  });
}

//集采为你推荐
export function userInnerRecommeds(query) {
  return http.request({
    url: `/mro/portal/product/userInnerRecommeds`,
    method: 'get',
    params: query,
  });
}
// 中小企业未登录为你推荐 mro/portal/product/restful/innerAutoRecommeds
export function innerAutoRecommeds(query) {
  return http.request({
    url: `/mro/portal/product/restful/innerAutoRecommeds`,
    method: 'get',
    params: query,
  });
}

// 新增分类关联商品 /categoryProduct

export function addCategoryProduct(data) {
  return http.request({
    url: '/mro/categoryProduct',
    method: 'post',
    data,
  });
}

// 删除分类关联商品 /categoryProduct

export function delCategoryProduct(data) {
  return http.request({
    url: '/mro/categoryProduct',
    method: 'delete',
    data,
  });
}
//自营用户登录后为你推荐
export function userSopRecommends(query) {
  return http.request({
    url: `/mro/portal/product/userSopRecommends`,
    method: 'get',
    params: query,
  });
}

//自营访客为你推荐
export function sopRecommends(query) {
  return http.request({
    url: `/mro/portal/product/restful/sopRecommends`,
    method: 'get',
    params: query,
  });
}

//自营新品推荐
export function getSopList(query) {
  return http.request({
    url: `/mro/newRecmd/rest/getSopList`,
    method: 'get',
    params: query,
  });
}

// 集采新品推荐
export function getRestInnerList(query) {
  return http.request({
    url: `/mro/newRecmd/rest/getInnerList`,
    method: 'get',
    params: query,
  });
}
export function getInnerList(query) {
  return http.request({
    url: `/mro/newRecmd/getInnerList`,
    method: 'get',
    params: query,
  });
}

// 首页外部热门推荐
export function getPopularRecommend(query) {
  return http.request({
    url: `/mro/portal/product/restful/popularRecommend`,
    method: 'get',
    params: query,
  });
}
// 首页内部热门推荐
export function getINPopularRecommend(query) {
  return http.request({
    url: `/mro/portal/product/popularRecommend`,
    method: 'get',
    params: query,
  });
}

//未登录时聚合搜索
export function getAllSopListRestful(query) {
  return http.request({
    url: `/mro/portal/product/restful/getSopList`,
    method: 'get',
    params: query,
  });
}

export function getAllSopList(query) {
  return http.request({
    url: `/mro/portal/product/searchAll`,
    method: 'get',
    params: query,
  });
}

// 未登录
export function getRestAllSopList(query) {
  return http.request({
    url: `/mro/portal/product/restful/searchAll`,
    method: 'get',
    params: query,
  });
}

//获取分类树
export function getCategoryTree(query) {
  return http.request({
    url: `/mro/category/restful/searchPortalCategoryTree`,
    method: 'get',
    params: query,
  });
}

//获取关联品牌
export function getBrandList(query) {
  return http.request({
    url: `/mro/brand/restful/portalBrand`,
    method: 'get',
    params: query,
  });
}

export function getBrandListInner(query) {
  return http.request({
    url: `/mro/brand/portalBrand`,
    method: 'get',
    params: query,
  });
}

// 搜索有产品的品牌
export function getBrandListSearch(query) {
  return http.request({
    url: `/mro/brand/restful/searchBrand`,
    method: 'get',
    params: query,
  });
}

export function getBrandListSearchInner(query) {
  return http.request({
    url: `/mro/brand/searchBrand`,
    method: 'get',
    params: query,
  });
}

// 获取推荐套餐
export function getRecommendPackage(query) {
  return http.request({
    url: `/mro/portal/productPackage/rest/sopRecommdList`,
    method: 'get',
    params: query,
  });
}

export function getRecommendPackageInner(query) {
  return http.request({
    url: `/mro/portal/productPackage/rest/innerRecommdList`,
    method: 'get',
    params: query,
  });
}

// 获取所有套餐
export function getAllPackage(query) {
  return http.request({
    url: `/mro/portal/productPackage/rest/getList`,
    method: 'get',
    params: query,
  });
}

export function getAllPackageInner(query) {
  return http.request({
    url: `/mro/portal/productPackage/rest/innerList`,
    method: 'get',
    params: query,
  });
}

// 根据供应商获取产品 /mro/portal/product/restful/getProductSkuInfos
export function getProductSkuInfos(query) {
  return http.request({
    url: `/mro/portal/product/restful/getProductSkuInfos`,
    method: 'get',
    params: query,
  });
}

// 积分产品 /mro/portal/product/restful/getPointMallList
export function getPointMallList(query) {
  return http.request({
    url: `/mro/portal/product/restful/getPointMallList`,
    method: 'get',
    params: query,
  });
}
// /portal/product/restful/getPortalProduct 活动产品拉取
export function getPortalProduct(query) {
  const { pageSize, pageNum } = query;
  return http.request({
    url: `/mro/portal/product/restful/getPortalProduct`,
    method: 'post',
    data: query,
    params: { pageSize, pageNum },
  });
}

// mro/category/getCategoryListBySupper/{supplierCompanyId} 根据供应商查id
export function getCategoryListBySupper(supplierCompanyId) {
  return http.request({
    url: `/mro/category/restful/getCategoryListBySupper/${supplierCompanyId}`,
    method: 'get',
  });
}
